import { CALL_API } from "../../middlewares/api";

export const BORROWER_NOTE_GET_REQUEST = "BORROWER_NOTE_GET_REQUEST";
export const BORROWER_NOTE_GET_SUCCESS = "BORROWER_NOTE_GET_SUCCESS";
export const BORROWER_NOTE_GET_ERROR = "BORROWER_NOTE_GET_ERROR";

export const INVESTOR_NOTE_GET_REQUEST = "INVESTOR_NOTE_GET_REQUEST";
export const INVESTOR_NOTE_GET_SUCCESS = "INVESTOR_NOTE_GET_SUCCESS";
export const INVESTOR_NOTE_GET_ERROR = "INVESTOR_NOTE_GET_ERROR";

export function get_notes_by_id(id, isInvestor = false) {
  const endpoint = isInvestor
    ? "/savelend/get-investor-by-id?investorId="
    : "/loanstep/get-borrower-by-id?borrowerId=";
  const types = isInvestor
    ? [
        INVESTOR_NOTE_GET_REQUEST,
        INVESTOR_NOTE_GET_SUCCESS,
        INVESTOR_NOTE_GET_ERROR,
      ]
    : [
        BORROWER_NOTE_GET_REQUEST,
        BORROWER_NOTE_GET_SUCCESS,
        BORROWER_NOTE_GET_ERROR,
      ];
  return {
    [CALL_API]: {
      endpoint: "/api/admin" + endpoint + id,
      method: "GET",
      additionalData: id,
      types: types,
      authenticatedRequest: true,
    },
  };
}
